export default __webpack_public_path__ + "static/O0236-838713a0a7f4fa0a2bef18df4340490c.png";